import { render, staticRenderFns } from "../../../pages/physician/notic/notic.html?vue&type=template&id=570a24b8&scoped=true&"
import script from "../../../pages/physician/notic/notic.js?vue&type=script&lang=js&"
export * from "../../../pages/physician/notic/notic.js?vue&type=script&lang=js&"
import style0 from "../../../pages/physician/notic/notic.css?vue&type=style&index=0&id=570a24b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570a24b8",
  null
  
)

export default component.exports